import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as PushAPI from "@/api/push";
import { CommonResponse, isSuccess } from "@/api/response";
import { ChangeFixedRequest } from "@/api/push/request";

const MODULE_NAME = "push/changePushFixed";

/**
 * プッシュメッセージ固定表示変更APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class ChangeFixed extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  // MutationActions
  @MutationAction
  async changeFixedOne(changeFixedRequest: ChangeFixedRequest) {
    const commonResponse = await PushAPI.changeFixedOne(changeFixedRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(ChangeFixed);
